<template>
  <div class="powered_by__main z-50 sticky bottom-0">
    <div class="powered_by__inner w-full py-5 px-5 md:px-10">
      <div class="powered_by__link block w-full md:flex">
        <div class="powered_by__logo w-full text-right md:flex-grow md:order-2">
          <a href="https://patientpoint.com" target="_blank" rel="noopener noreferrer">
            <img :src="image" class="footer_logo inline-block" alt="Content powered by PatientPoint" />
          </a>
        </div>
        <div class="powered_by__copyright block w-full mt-4 text-right md:text-left md:mt-0 md:flex-grow md:order-1">
          <span class="powered_by__separator">©2018-{{ new Date().getFullYear() }} PatientPoint, LLC</span>
          <span class="powered_by__separator"> | </span>
          <a href="https://patientpoint.com/about" target="_blank" rel="noopener noreferrer">About PatientPoint</a>
          <span class="powered_by__separator"> | </span>
          <a href="https://patientpoint.com/terms-conditions/" target="_blank" rel="noopener noreferrer">PatientPoint Terms of Use</a>
          <span class="powered_by__separator"> | </span>
          <a href="https://patientpoint.com/privacy-policy/" target="_blank" rel="noopener noreferrer">PatientPoint Privacy Policy</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script >

import image from '../assets/img/PatientPoint-Logo-NM-2024-264x80.jpg';

export default {
  data(){
    return{
      image: image
    }
  },
}
 
</script>

<style scoped>
.powered_by__main {
  @apply text-pp-gray-light;
  @apply bg-white;
  @apply text-sm;
  /* The TailwindCSS shadow was not applying. */
  box-shadow: 0 0 15px rgb(0, 0, 0, 0.2);
}

.powered_by__inner {
  @apply justify-center;
}

.powered_by__separator {
  @apply text-pp-orange;
}

.powered_by__copyright {
  @apply text-xs;
  @apply text-pp-orange;
  margin-top: 0.5rem;
}

.powered_by__copyright a {
  @apply text-pp-orange;
  @apply no-underline;
}

.powered_by__copyright a:hover {
  @apply underline;
}

.footer_logo {
  width:150px;
}

</style>
